/**
 * @author Max Erekhinskiy <max.erekhinskiy@gmail.com>, Jun 28, 2012 11:51:23 AM
 * @copyright MegaGroup © 2012, megagroup.ru
 */

(function() {
	'use strict';
    var $ = Onicon.$;
    var Handlebars = Onicon.hb;

	var dom = {
		fixed_intervals: {},

		fixed_exists: null,

        getDocumentZoom : function() {
			if (Onicon.navigator.isiOS) {
				return window.innerWidth / screen.width;
			} else {
				return window.innerWidth / window.outerWidth;
			}
        },


		attachEvent: function (event, func, object) {
			var obj = object || (/resize|unload|beforeunload|scroll|hashchange/.test(event) ? window : document);
			if (obj.addEventListener) {
				return obj.addEventListener(event, func, false);
			} else if (obj.attachEvent) {
				return obj.attachEvent('on' + event, func);
			}
			return false;
		},


		detachEvent: function (event, func, object) {
			var obj = object || (/resize|unload|beforeunload|scroll|hashchange/.test(event) ? window : document);
			if (obj.removeEventListener) {
				return obj.removeEventListener(event, func, false);
			} else if (obj.detachEvent) {
				return obj.detachEvent('on' + event, func);
			}
			return false;
		},


		trim: function (string) {
			return string.replace(/^\s+|\s+$/g, '');
		},


		HTMLSpecialChars: function (str, decode) {
			var converts, i, pattern_no, replacement_no;
			str += '';

			if (decode) {
				pattern_no = 1;
				replacement_no = 0;
			} else {
				pattern_no = 0;
				replacement_no = 1;
			}

			converts = [
				['<', '&lt;'],
				['>', '&gt;'],
//				['&', '&amp;'],
				['"', '&quot;']
			];

			for (i = 0; i < converts.length; ++i) {
				str = str.replace(new RegExp(converts[i][pattern_no], 'gi'), converts[i][replacement_no]);
			}

			return str;
		},


		arraySome: function (array, cb, this_to_element) {
			for (var i = 0; i < array.length; ++i) {
				if (cb.call(this_to_element ? array[i] : window, array[i])) {
					return true;
				}
			}
			return false;
		},

		objectHasOwnValue: function (object, needle) {
			for (var i in object) {
				if (object.hasOwnProperty(i) && object[i] === needle) {
					return i;
				}
			}
			return null;
		},

		addClass: function (node, class_name) {
			if (!(new RegExp('(^|\\s)' + class_name + '(\\s|$)')).test(node.className)) {
				node.className += ' ' + class_name;
			}
			node.className = node.className.replace(/\s+/g, ' ').replace(/^\s|\s$/g, '');
		},


		removeClass: function (node, class_name) {
			var classes = node.className.replace(/\s+/gm, ' ').split(' '), result = [], i = -1;
			while (++i < classes.length) {
				if (classes[i] !== '' && classes[i] !== class_name) {
					result.push(classes[i]);
				}
			}
			node.className = result.join(' ');
		},

		toggleClass: function(node, class_name) {
			if (core.hasClass(node, class_name)) {
				core.removeClass(node, class_name);
			} else {
				core.addClass(node, class_name);
			}
		},

		hasClass: function (node, class_name) {
			if(node) {
				return new RegExp('(^|\\s)' + class_name + '(\\s|$)').test(node.className.replace(/\s+/mg, ' ').replace(/^\s+|\s+$/mg, ''));
			} else {
				Onicon.error('Node is missed %s', class_name);
				return false;
			}
		},


		rand: function (min, max) {
			return Math.round((Math.random() * (max - min))) + min;
		},

		addDigits: function (nubmer, total_num_of_digits) {
			nubmer += '';
			total_num_of_digits = total_num_of_digits || 2;
			return (new Array(total_num_of_digits > nubmer.length ? total_num_of_digits - nubmer.length + 1 : 0)).join('0') + nubmer;
		},


		foreach: function (this_obj, array_var, func_processor) {
			for (var i in array_var) {
				if (array_var.hasOwnProperty(i)) {
					func_processor.call(this_obj, i, array_var[i]);
				}
			}
		},

		removeSelection: function () {
			if (window.getSelection) {
				window.getSelection().removeAllRanges();
			} else if (document.selection && document.selection.clear) {
				document.selection.clear();
			}
		},

		positionFixed: function (panel, x_side, y_side, x_margin, y_margin) {
			Onicon.log('[library.positionFixed] Input Pos', panel.id, x_side, y_side, x_margin, y_margin);
			var dom = this;

			if (Onicon.core.repositioning === 0) {
				return;
			}

			x_margin = Math.max(+x_margin || 0, 0);
			y_margin = Math.max(+y_margin || 0, 0);
			x_side = x_side || 'right';
			y_side = y_side || 'bottom';

			// if (dom.fixed_exists === null) {
			// 	var tmp = document.createElement('div');
			// 	tmp.style.position = 'fixed';
			// 	tmp.style.left = '-1000px';
			// 	tmp.style.top = '-1000px';
			// 	tmp.style.margin = 0;
			// 	document.body.appendChild(tmp);
			// 	dom.fixed_exists = tmp.offsetLeft < 0;
			// 	document.body.removeChild(tmp);
			// }

			// var position = dom.fixed_exists ? 'fixed' : 'absolute',
			var position = 'fixed',
				document_width = dom.documentWidth(),
				document_height = dom.documentHeight(),
				saved_display_state = dom.cssGet(panel, 'display'),
				panel_width, panel_height, check_pos_x, check_pos_y, top, left,
				no_visibility = false;

			if (Onicon.navigator.isMobile && Onicon.core.getById('bookmark')) {
				var zoom = dom.getDocumentZoom();
				Onicon.core.getById('bookmark').style.zoom = 1 * zoom;
				Onicon.core.getById('panel').style.zoom = 1 * zoom;
				document_height = document_height / zoom;
				document_width = document_width / zoom;
			}

			if(panel.style.visibility == "") {
				panel.style.visibility = 'hidden';
				no_visibility = true
			}

			panel.style.position = position;
			panel.style.left = '0px';
			panel.style.top = '0px';

			if (saved_display_state === 'none') {
				panel.style.display = '';
			}

			panel_width = panel.offsetWidth;
			panel_height = panel.offsetHeight;

			if(no_visibility) {
				panel.style.visibility = '';
			}

			panel.style.display = saved_display_state;

			Onicon.log('[library.positionFixed] Mesured values: width: %s, height: %s, doc_width: %s, doc_height: %s',
				panel_width, panel_height, document_width, document_height);

			check_pos_x = document_width - x_margin - panel_width;
			check_pos_y = document_height - y_margin - panel_height;

			if (check_pos_x < 0) {
				x_margin = Math.max(x_margin + check_pos_x, 0);
			}
			if (check_pos_y < 0) {
				y_margin = Math.max(y_margin + check_pos_y, 0);
			}

			switch(x_side) {
				case 'left': left = x_margin; break;
				case 'center': left = document_width / 2 - panel_width / 2 - x_margin; break;
				case 'right': left = document_width - panel_width - x_margin;
			}

			switch(y_side) {
				case 'top': top = y_margin; break;
				case 'center': top = document_height / 2 - panel_height / 2 - y_margin; break;
				case 'bottom': top = document_height - panel_height - y_margin;
			}

			Onicon.log('[library.positionFixed] Calculated values: x: %s, y: %s', left, top);


			var tmp = document_height - top - panel_height;
			if (tmp < 0) {
				top += tmp;
			}

			tmp = document_width - left - panel_width;
			if (tmp < 0) {
				left += tmp;
			}

			// if (!dom.fixed_exists) {
			// 	top += this.scrollY();
			// 	left += this.scrollX();
			// }

			if (Onicon.navigator.isMobile) {
				if (this.scrollY() < panel_height + (panel_height - document_height)) {
					top -= (this.scrollY() / zoom) - (panel_height - document_height);
				} else {
					top = document_height - panel_height;
				}
			} else {
				if (top < 0 ) {
					top = 0;
				}
			}

			panel.style.position = position;
			panel.style.top = top + 'px';
			panel.style.left = left + 'px';
		},

        callbackOnCenter: function(bookmark, call_button) {
	    if(bookmark.tagName != 'IMG') {
            	var b_margin_top = call_button.style.marginTop,
                	helper = Onicon.core.getById('onicon-bookmark-helper'),
                	margin_digit = parseInt(b_margin_top.replace(/\D+/g,"")),
                	b_width = helper.offsetWidth,
                	b_top = bookmark.offsetTop,
                	bkCoordinate = bookmark.getBoundingClientRect();

            	b_width += 80;

            	if(bookmark.className.indexOf('onicon_chat-hint_right') != -1) { //right side
                	if(b_margin_top != 'auto') {
                    		call_button.style.top = b_width/3 + margin_digit + bkCoordinate.top + 'px';
                	} else {
                    		call_button.style.top = b_width/3 + bkCoordinate.top + 'px';
                	}
            	}
           	else if(bookmark.className.indexOf('onicon_chat-hint_left') != -1 ) { //Left side
                	if(b_margin_top != 'auto') {
                    		call_button.style.top = b_top - margin_digit - b_width/3*2 + 'px';
                	} else if(bookmark.className.indexOf('onicon_chat-hint-position_left-top') != -1 ) {
                    		call_button.style.top = b_width/3 + 5 + 'px';
                	}
            	}
	    }
        },

        positionBookmark: function(panel, x_side, y_side, x_margin, y_margin, orientation, callbutton) {
            // Helper узнаём фактическую длинну закладки,
            // размер которой меняется в зависимости от длинны текста

            if (!panel) return;

            var helper = Onicon.core.getById('onicon-bookmark-helper');

            if (!helper) {
                // Определить тип исходного элемента
                if (panel.tagName == 'IMG') {
                    helper = panel.cloneNode(true);
                } else {
                    helper = panel.children[0].children[1].cloneNode(true);
                }

                helper.id = Onicon.core.createId('onicon-bookmark-helper');
                helper.style.visibility = 'hidden';
                helper.style.left = '-9999px';
                helper.style.position = 'fixed';
                helper.style.fontWeight = 'bold';
                helper.style.maxWidth = '300px';
                document.body.appendChild(helper);
            }

			var delta = helper.offsetWidth / 2;

            var top = y_side.indexOf('top') != -1 ? parseInt(y_margin) : 'auto',
                bottom = y_side.indexOf('bottom') != -1 ? parseInt(y_margin): 'auto',
                left = x_side.indexOf('left') != -1 ? parseInt(x_margin) : 'auto',
                right = x_side.indexOf('right') != -1 ? parseInt(x_margin) : 'auto',
                margin_left = 'auto',
                margin_top = 'auto';
            if (x_side.indexOf('center') != -1) {
                left = '50%';
                margin_left = -delta;
            } else if (y_side.indexOf('center') != -1) {
                top = '50%';
                margin_top = (x_side == 'left' ? delta*2: -delta*2);
            }

            if (orientation == 'vertical' && y_side != 'center') {
                if (x_side == 'left') {
                    if (y_side == 'bottom') {
                        bottom = (bottom - delta/2) + 15;
                    } else {
                        top = (top + delta*2) + 70;
                    }
                } else if (x_side == 'right') {
                    if (y_side == 'bottom') {
                        bottom = (bottom + delta*2) + 80;
                    } else {
                        top = (top - delta/2) + 15;
                    }
                }
            }

            if (orientation == 'horizontal' && y_side == 'top') {
                top += 10;
            }

            if (x_side == 'left' && margin_left == 'auto') {
                left += 10;
            }

            // Позиционирование оникона и кнопки обратного звонка
            if(callbutton) {
                Onicon.dom.addClass(panel, 'onicon-callme--' + x_side);
            } else {
                if(panel.tagName == 'IMG') {    //кастомная кнопка
                    Onicon.dom.addClass(panel, 'onicon_chat-hint_custom');
                    if(x_side == 'center') {
                        Onicon.dom.addClass(panel, 'onicon_chat-hint_'+y_side);
                        Onicon.dom.addClass(panel, 'onicon_chat-hint-position_'+y_side+'-'+x_side);
                    } else {
                        Onicon.dom.addClass(panel, 'onicon_chat-hint_'+x_side);
                        Onicon.dom.addClass(panel, 'onicon_chat-hint-position_'+x_side+'-'+y_side);
                    }
                } else {
                    // Стандартная
                    if(orientation == 'horizontal') {
                        Onicon.dom.addClass(panel, 'onicon_chat-hint_' + y_side);
                        Onicon.dom.addClass(panel, 'onicon_chat-hint-position_' + y_side+'-'+ x_side);
                    } else {
                        Onicon.dom.addClass(panel, 'onicon_chat-hint_' + x_side);
                        Onicon.dom.addClass(panel, 'onicon_chat-hint-position_' + x_side+'-'+ y_side);
                    }
                }
            }

            var zoom = Onicon.dom.getDocumentZoom();
            var scrollX = window.pageXOffset;
            var scrollY = window.pageYOffset;

            var css = {
                position: 'fixed',
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                marginTop: margin_top,
                marginLeft: margin_left
            };
            this.cssSet(panel, css);
        },

		draggable: function (config) {
			if(!config) {
				Onicon.error('[library:draggable] Config is not defined');
			}

			var target_object = config.target, pointer = config.pointer, on_start = config.on_start,
				on_move = config.on_move, on_end = config.on_end, on_click = config.on_click,
				direction_x = config.position_x, direction_y = config.position_y, moved = false;

			var moving = false;
			var mousedown = function (e) {
				e = e || window.event;
				if ((target_object.addEventListener && e.button === 0) || (!target_object.addEventListener && e.button === 1)) {
					var offset_target_object = dom.offset(target_object),
						offset_target = dom.offset(e.target || e.srcElement);
					moving = {
						x : (isFinite(e.offsetX) ? e.offsetX : e.layerX) + (offset_target.left - offset_target_object.left),
						y : (isFinite(e.offsetY) ? e.offsetY : e.layerY) + (offset_target.top - offset_target_object.top)
					};
					if (e.preventDefault) e.preventDefault();
					if (on_start && typeof(on_start) == 'function') on_start.call(this);
                    moved = false;
				}
			};

			dom.attachEvent('mousedown', mousedown, pointer);
			dom.attachEvent('mousemove', function (e) {
				if (moving) {
                    moved = true;
					e = e || window.event;
					var margin_x = e.clientX - moving.x,
						margin_y = e.clientY - moving.y,
						delta = dom.documentWidth() - margin_x - target_object.offsetWidth;
					if (direction_x === 'right') {
						margin_x = delta > 0 ? delta : 0;
					} else if (delta < 0) {
						margin_x += delta;
					}
					direction_y === 'bottom' && (margin_y = Math.max(dom.documentHeight() - margin_y - target_object.offsetHeight, 0));
					dom.removeSelection();

					if(on_move && typeof(on_move) == 'function') {
						on_move.call(this, margin_x, margin_y);
					}
				}
			});

			dom.attachEvent('mouseup', function (e) {
				moving = false;
				if (on_end && typeof(on_end) == 'function') on_end.call(this);
                if (e.target == pointer && on_click && typeof(on_click) == 'function' && !moved) on_click.call(this);
 			});
		},

		getXMargin : function(left_margin, object, inverse) {
			if(inverse) {
				return dom.documentWidth() - left_margin - object.offsetWidth;
			} else {
				return left_margin;
			}
		},

		getYMargin : function(top_margin, object, inverse) {
			if(inverse) {
				return dom.documentHeight() - top_margin - object.offsetHeight;
			} else {
				return top_margin;
			}
		},

		offset: function (elem) {
			var offset = {top: 0, left: 0}, t = elem;

			if (elem.getBoundingClientRect) {
				t = elem.getBoundingClientRect();
				offset.top = t.top + this.scrollY() - this.clientY();
				offset.left = t.left + this.scrollX() - this.clientX();
			} else {
				while (t) {
					offset.top += t.offsetTop;
					offset.left += t.offsetLeft;
					t = t.offsetParent;
				}
			}
			return offset;
		},

		scrollX: function () {
			return window.scrollX || window.pageX || document.body.scrollLeft || document.documentElement.scrollLeft;
		},

		scrollY: function () {
			return window.scrollY || window.pageY || document.body.scrollTop || document.documentElement.scrollTop;
		},

		clientX: function () {
			return document.body.clientLeft || document.documentElement.clientLeft || 0;
		},

		clientY: function () {
			return document.body.clientTop || document.documentElement.clientTop || 0;
		},

		documentWidth: function () {
			if (Onicon.lib('navigator').isAndroid && window.innerWidth) {
				return window.innerWidth;
			}
			return document.compatMode === "CSS1Compat" ? document.documentElement.clientWidth : document.body.clientWidth;
		},

		documentHeight: function () {
			if (window.Onicon.lib('navigator').isAndroid && window.innerHeight) {
				return window.innerHeight;
			}
			return document.compatMode === "CSS1Compat" ? document.documentElement.clientHeight : document.body.clientHeight;
		},

		cssInt: function (elem, name) {
			name = parseInt(this.cssGet(elem, name), 10);
			return isFinite(name) ? name : 0;
		},

		cssGet: function (elem, name) {
			return (elem && elem.currentStyle ? elem.currentStyle : (window.getComputedStyle ? window.getComputedStyle(elem, '') : {}))[name];
		},

        cssSet : function (elem, css) {
            var px_properties = [
                'top', 'left', 'right', 'bottom', 'margin', 'padding',
                'marginLeft', 'marginRight', 'marginTop', 'marginBottom'
            ];

            for (var property in css) {
                var item = css[property].toString();
                if (/^-?\d+[.\d+]{0,10}$/.test(item) && px_properties.indexOf(property) != -1) {
	                if (item.indexOf('%') == -1) {
		                item += 'px';
	                }
                }
                elem.style[property] = item;
                Onicon.log('[CSS Set] Property: '+property+': '+item);
            }
        },

		removeElement: function (element) {
			return element ? element.parentNode.removeChild(element) : false;
		},

		getElementById: function (id) {
			return document.getElementById(id);
		},

		elementChildren: function (element) {
			var childNodes = element.childNodes,
				children = [],
				i = childNodes.length;

			while (i--) {
				if (childNodes[i].nodeType == 1) {
					children.unshift(childNodes[i]);
				}
			}

			return children;
		},

        getElementsByAttribute: function (attribute, context) {
            var nodeList = (context || document).getElementsByTagName('*'),
                nodeArray = [],
                iterator = 0,
                node = null;

            while (node = nodeList[iterator++]) {
                if (node.getAttribute(attribute)) nodeArray.push(node);
            }

            return nodeArray;
        },

		insertAtCaret: function (element, value, value_end) {
			if (element) {
				var document_range, start_pos, end_pos, scroll_top;
				if (document.selection) {
					element.focus();
					document_range = document.selection.createRange();
					if(value_end) {
						document_range.text = value + document_range.text + value_end;
					} else {
						document_range.text = value;
					}
					document_range.select();
					element.focus();
				} else if (element.selectionStart !== undefined) {
					start_pos = element.selectionStart;
					end_pos = element.selectionEnd;
					scroll_top = element.scrollTop;
					if(value_end) {
						var wrapped_value = value + element.value.substring(start_pos, end_pos) + value_end;
						var inserted_length = wrapped_value.length;
						element.value = element.value.substring(0, start_pos) + wrapped_value + element.value.substring(end_pos, element.value.length);
					} else {
						var inserted_length = value.length;
						element.value = element.value.substring(0, start_pos) + value + element.value.substring(end_pos, element.value.length);
					}
					element.focus();
					element.selectionStart = start_pos + inserted_length;
					element.selectionEnd = start_pos + inserted_length;
					element.scrollTop = scroll_top;
				} else {
					element.value += value + (value_end ? value_end : '');
				}
			}
		},

		getSelectedText : function(){
			var t = '';
			if(window.getSelection){
				t = window.getSelection();
			}else if(document.getSelection){
				t = document.getSelection();
			}else if(document.selection){
				t = document.selection.createRange().text;
			}
			return t.toString();
		},

		setSelectionRange: function (input, selectionStart, selectionEnd) {
			if (input.setSelectionRange) {
				input.focus();
				input.setSelectionRange(selectionStart, selectionEnd);
			} else if (input.createTextRange) {
				var range = input.createTextRange();
				range.collapse(true);
				range.moveEnd('character', selectionEnd);
				range.moveStart('character', selectionStart);
				range.select();
			}
		},

		moveCarete: function (object, to_start) {
			var pos = to_start ? 0 : object.value.length;
			Onicon.dom.setSelectionRange(object, pos, pos);
			if (!object) {
				Onicon.error('Wrong object', object);
			}
		},

		getDataFromClass: function (obj, class_name) {
			if (obj && obj.className && typeof(obj.className) === 'string' && typeof(class_name) === 'string') {
				var match = obj.className.match(new RegExp('(?:' + class_name + '-)([^\\s.]+?)(\\s|$)', 'i'));
				return match && match[1] !== undefined ? match[1] : null;
			}

			return false;
		},

		smartReplace: function (template, replace_object, delimiter) {
			delimiter = delimiter || '*';
			for (var prop_name in replace_object) {
				template = template.replace(new RegExp('\\' + delimiter + prop_name + '\\' + delimiter, 'ig'), replace_object[prop_name]);
			}

			return template;
		},

		htmlspecialchars_decode: function (string, quote_style) {
			// http://kevin.vanzonneveld.net
			var optTemp = 0,
				i = 0,
				noquotes = false;
			if (typeof quote_style === 'undefined') {
				quote_style = 2;
			}
			string = string.toString().replace(/&lt;/g, '<').replace(/&gt;/g, '>');
			var OPTS = {
				'ENT_NOQUOTES': 0,
				'ENT_HTML_QUOTE_SINGLE': 1,
				'ENT_HTML_QUOTE_DOUBLE': 2,
				'ENT_COMPAT': 2,
				'ENT_QUOTES': 3,
				'ENT_IGNORE': 4
			};
			if (quote_style === 0) {
				noquotes = true;
			}
			if (typeof quote_style !== 'number') { // Allow for a single string or an array of string flags
				quote_style = [].concat(quote_style);
				for (i = 0; i < quote_style.length; i++) {
					// Resolve string input to bitwise e.g. 'PATHINFO_EXTENSION' becomes 4
					if (OPTS[quote_style[i]] === 0) {
						noquotes = true;
					} else if (OPTS[quote_style[i]]) {
						optTemp = optTemp | OPTS[quote_style[i]];
					}
				}
				quote_style = optTemp;
			}
			if (quote_style & OPTS.ENT_HTML_QUOTE_SINGLE) {
				string = string.replace(/&#0*39;/g, "'"); // PHP doesn't currently escape if more than one 0, but it should
				// string = string.replace(/&apos;|&#x0*27;/g, "'"); // This would also be useful here, but not a part of PHP
			}
			if (!noquotes) {
				string = string.replace(/&quot;/g, '"');
			}
			// Put this in last place to avoid escape being double-decoded
			string = string.replace(/&amp;/g, '&');

			return string;
		},

		countObjectProperties: function (object) {
			if (object && typeof(object) === 'object') {
				var num = 0;
				for (var prop in object) {
					if (object.hasOwnProperty(prop)) {
						num++;
					}
				}
				return num;
			}
			return false;
		},

        createNode: function (tag, id, _class) {
            var node = document.createElement(tag);
            if (id) node.id = id;
            if (_class) this.addClass(node, _class);
            return node;
        }
	};


	var datesync = {
		full_correct: null,

		init: function (server_seconds, server_timezone) {
			Onicon.log("[library.datesync] Datesync initialize: ", server_seconds, server_timezone);
			this.full_correct = server_seconds - Math.round((new Date().getTime()) / 1000);
			Onicon.log("[library.datesync] Calculated correct: ", this.full_correct);
		},

		correct: function (seconds, return_as_date, client) {
			var corrected_seconds;
			if (this.full_correct === null) {
				Onicon.error("[library.datesync] Datesync is not ready!");
				corrected_seconds = +seconds;
			} else {
				corrected_seconds = seconds - (client ? -1 : 1) * this.full_correct;
			}

			//Onicon.log("[library.datesync] Correct: ", seconds, return_as_date, client, ' corrected: ', corrected_seconds);
			return return_as_date ? new Date(corrected_seconds * 1000) : corrected_seconds;
		},

		client_correct: function (seconds, return_as_date) {
			return this.correct(seconds, return_as_date, true);
		},

		server_correct: function (seconds, return_as_date) {
			return this.correct(seconds, return_as_date, false);
		}
	};

	var trigger = {
		events: {},
		ev_map : {},

		EV_AUTHORIZED_ONCE : null,		// Onicon success Auth, triggers only on first Auth
		EV_AUTHORIZED : null,			// Onicon success Auth, triggers every Auth

		EV_WORKING : null,
		EV_WORKING_ONCE : null,

		EV_V_OPERATOR_COME_TO_CHAT : null,
		EV_V_OPERATOR_LEAVE_CHAT : null,
		EV_V_OPERATOR_COME_TO_SITE : null,
		EV_V_OPERATOR_LEAVE_SITE : null,

		EV_V_VISITOR_TYPING : null,
		EV_V_VISITOR_TYPING_ONCE : null,

		EV_V_USER_UPDATED : null,

		EV_V_PANEL_SHOW : null,
		EV_V_PANEL_HIDE : null,

        EV_V_SITE_CLOSE : null,

		EV_V_HASH_CHANGED : null,
		EV_V_SAS_LOADED : null,

		EV_PACKET : null,

		EV_O_USER_INFO_CHANGED : null,
		EV_O_TAB_SELECTED : null,
		EV_O_VISITOR_CALL : null,
		EV_O_DIALOG_CREATED : null,

		EV_PACKET_TOKEN : function(token) {
			return trigger.EV_PACKET + ':' + token;
		},

		init : function() {
			var ev_code = 0;

			for(var prop_name in trigger) {
				if(trigger.hasOwnProperty(prop_name) && prop_name.match('EV_') && trigger[prop_name] === null) {
					trigger[prop_name] = ++ev_code;
					trigger.ev_map[trigger[prop_name]] = prop_name;
				}
			}
		},

		ready : function() {
			if(Onicon.DEBUG) {
				for(var prop_name in trigger) {
					if(trigger.hasOwnProperty(prop_name) && prop_name.match('EV_')) {
						(function(prop_name) {
							trigger.bind(trigger[prop_name], function() {
								Onicon.log('[trigger] DEBUG EV: ' + prop_name, arguments);
							});
						})(prop_name);
					}
				}
			}
		},

		bindonce: function (name, callback) {
			this._bind(name, callback, true);
		},

		bind: function (name, callback) {
			this._bind(name, callback, false);
		},

		_bind: function (name, callback, once) {
			if (!this.events[name]) {
				this.events[name] = [];
			}

			if (callback && typeof callback === 'function') {
				this.events[name].push({callback : callback, once : once});
			}
		},

		unbind: function (name) {
			if (this.events[name]) {
				delete this.events[name];
			}
		},

		execute: function () {
			if(!arguments.length) {
				Onicon.error('[trigger] Wrong trigger.execute call');
				return false;
			}
			trigger.trigger.apply(trigger, arguments);
		},

		trigger: function (name) {
			if (!name) {
				Onicon.error('[library:trigger.trigger] name must be defined');
				return;
			}

			if(!isNaN(name) && !trigger.ev_map[name]) {
				Onicon.error('[library:trigger.trigger] undeclared trigger execution ' + name + ' ' + trigger.ev_map[name] + parseInt(name));
				return;
			}

			if (!this.events[name]) {
				Onicon.log('[library:trigger.trigger] Has no listeners for event: ' + name);
				return;
			}

			Onicon.log('[library:trigger.trigger] Executing event: ' + name);

			var events = this.events[name], args = [], indexes_to_delete = [], i, j;
			for (i = 1; i < arguments.length; i++) {
				args.push(arguments[i]);
			}

			for (i in events) {
				if (events.hasOwnProperty(i)) {
					if (events[i].callback) {
						events[i].callback.apply(Onicon.lib('core'), args);
					}

					if (events[i].once || !events[i].callback) {
						indexes_to_delete.push(i);
					}
				}
			}

			for (j in indexes_to_delete) {
				if (indexes_to_delete.hasOwnProperty(j)) {
					i = indexes_to_delete[j];
					events.splice(i, 1);
				}
			}

			if (events.length == 0) {
				delete(this.events[name]);
			}
		}
	};

	var mStorageCollection = function (parent, key) {
		this.length = 0;
		this.length_data = 0;
		this.length_collections = 0;
		this.data = {};
		this.parent = parent;
		this.key = key;
	};

	mStorageCollection.prototype = {
		constructor: mStorageCollection,
		TYPE_DATA: 1,
		TYPE_COLLECTION: 2,
		TYPE_ALL: 0
	};

	mStorageCollection.prototype.getObjects = function (recursive, type, with_keys) {
		recursive = recursive && true;
		with_keys = with_keys || false;
		type = type || this.TYPE_ALL;

		var array_to_return = [],
			object_to_return = {}, i, j;

		for (i in this.data) {
			if (this.data.hasOwnProperty(i)) {
				var prop = this.data[i];

				if (prop instanceof mStorageCollection) {
					if (recursive) {
						var temp_result = prop.getObjects(recursive, type, with_keys);

						for (j in temp_result) {
							if (temp_result.hasOwnProperty(j)) {
								array_to_return.push(temp_result[j]);
								object_to_return[j] = temp_result[j];
							}
						}
					}

					if (type != this.TYPE_DATA) {
						array_to_return.push(this.data[i]);
						object_to_return[i] = this.data[i];
					}
				} else if (type != this.TYPE_COLLECTION) {
					array_to_return.push(prop);
					object_to_return[i] = prop;
				}
			}
		}

		return with_keys ? object_to_return : array_to_return;
	};

	mStorageCollection.prototype.getData = function (recursive, with_keys) {
		return this.getObjects(recursive, this.TYPE_DATA, with_keys);
	};

	mStorageCollection.prototype.getCollections = function (recursive, with_keys) {
		return this.getObjects(recursive, this.TYPE_COLLECTION, with_keys);
	};

	mStorageCollection.prototype.setObject = function (key, object) {
		this.data[key] = object;

		if (object instanceof mStorageCollection) {
			this.length_collections++;
		} else {
			this.length_data++;
		}

		this.length++;

		return object;
	};

	mStorageCollection.prototype.deleteObject = function (key) {
		if (this.data[key]) {
			var object_to_delete = this.data[key];

			if (this.data[key] instanceof mStorageCollection) {
				this.length_collections--;
			} else {
				this.length_data--;
			}

			this.length--;
			delete this.data[key];

			this.shake();
			return object_to_delete;
		}

		return false;
	};

	mStorageCollection.prototype.shake = function () {
		if (this.length == 0) {
			if (this.parent) {
				var parent = this.parent;
				var key = this.key;

				parent.deleteObject(key);
				parent.shake();
			}
		}
	};



	mStorageCollection.prototype.findCollectionByPath = function (path, create) {
		create = create || false;

		var path_node = path.reverse().pop();

		path.reverse();

		var inner_collections = this.getCollections(false, true);

		if (create && inner_collections[path_node] == undefined) {
			inner_collections[path_node] = this.setObject(path_node, new mStorageCollection(this, path_node));
		}

		if (inner_collections[path_node] != undefined) {
			return path.length
				? inner_collections[path_node].findCollectionByPath(path, create)
				: inner_collections[path_node];
		}

		return false;
	};

	var mStorage = function () {
		this.storage = new mStorageCollection(null, null);
	};

	mStorage.prototype.insert = function (path, key, object) {
		var collection = this.storage.findCollectionByPath(path, true);
		collection.setObject(key, object);
	};

	mStorage.prototype.find = function (condition, key, as_array) {
		condition = condition || [];
		as_array = as_array || false;
		key = key || null;

		var collection = condition.length ? this.storage.findCollectionByPath(condition) : this.storage;

		if (!collection) {
			return false;
		}

		var data = collection.getData(true, true);

		if (key) {
			return data[key] ? [data[key]] : null;
		}

		if (as_array) {
			var result = [];

			for (var o_key in data) {
				if (data.hasOwnProperty(o_key)) {
					result.push(data[o_key]);
				}
			}

			return result;
		}

		return data;
	};

	mStorage.prototype.findOne = function (condition, key) {
		var find = this.find(condition, key);

		if (find && find.length) {
			return find[0];
		}

		if (find instanceof Object) {
			for (var o_key in find) {
				if (find.hasOwnProperty(o_key)) {
					if (!key) {
						var result = {};
						result[o_key] = find[o_key];
						return result;
					}

					return find[o_key];
				}
			}
		}

		return find;
	};

	mStorage.prototype.remove = function(path, key) {
		path = path || [];

		var collection = path.length ? this.storage.findCollectionByPath(path) : this.storage;

		if (!collection) {
			return false;
		}

		if (key) {
			return collection.deleteObject(key);
		}

		if (collection.parent) {
			return collection.parent.deleteObject(collection.key);
		}

		return collection;
	};

	var local_storage = {
		isSupported : function() {
			try {
				return 'localStorage' in window && window['localStorage'];
			} catch(e) {
				return false;
			}
		},

		set : function(key, data) {
			if(local_storage.isSupported()) {
				if(key) {
					return window.localStorage.setItem(key, JSON.stringify(data));
				} else {
					Onicon.error('[local_storage:set] Cannot get value, wrong key');
					return false;
				}
			} else {
				Onicon.error('[local_storage:set] Cannot use localStorage: not supported');
				return false;
			}
		},

		get : function(key) {
			if(local_storage.isSupported()) {
				if(key) {
					return JSON.parse(window.localStorage.getItem(key));
				} else {
					Onicon.error('[local_storage:get] Cannot get value, wrong key');
					return false;
				}
			} else {
				Onicon.error('[local_storage:get] Cannot use localStorage: not supported');
				return false;
			}
		},

		remove : function(key) {
			if(local_storage.isSupported()) {
				if(key) {
					return window.localStorage.removeItem(key);
				} else {
					Onicon.error('[local_storage:remove] Cannot get value, wrong key');
					return false;
				}
			} else {
				Onicon.error('[local_storage:remove] Cannot use localStorage: not supported');
				return false;
			}
		}
	};

	var session_storage = {
		mode: 0,
		modes: {
			COOKIE: 1,
			HTML5: 2
		},

		init: function () {
			try {
				this.mode = window.sessionStorage ? this.modes.HTML5 : this.modes.COOKIE;
			} catch(e) {
				this.mode = this.modes.COOKIE;
			}
		},

		set: function (name, value) {
			if (typeof name !== 'string') {
				Onicon.error('[session_storage] Name must be a string');
				return false;
			}

			if (typeof value !== 'string') {
				Onicon.error('[session_storage] Value must be a string');
				return false;
			}

			value = encodeURIComponent(value);

			switch (this.mode) {
				case this.modes.COOKIE: Onicon.cookie.set(name, value, 0); break;
				case this.modes.HTML5: window.sessionStorage.setItem(name, value);
			}
		},

		get: function (name) {
			if (typeof name !== 'string') {
				Onicon.error('[session_storage] Name must be a string');
				return false;
			}

			var value = null;

			switch (this.mode) {
				case this.modes.COOKIE: value = Onicon.cookie.get(name); break;
				case this.modes.HTML5: value = window.sessionStorage.getItem(name);
			}

			return value ? decodeURIComponent(value) : null;
		},

		del: function (name) {
			if (typeof name !== 'string') {
				Onicon.error('[session_storage] Name must be a string');
				return false;
			}

			var value = '';
			switch (this.mode) {
				case this.modes.COOKIE: value = Onicon.cookie.remove(name); break;
				case this.modes.HTML5: value = window.sessionStorage.removeItem(name);
			}

			return decodeURIComponent(value);
		}
	};

	var formatter = {
		list : [
			{name : 'emoji', args: 1},
			{name : 'img', args : 1},
			{name : 'link', args : 2},
			{name : 'out', args : 3},
			{name : 'end', args : 2},
            {name : 'direct', args: 2}
		],

		parse : function(string) {
			for(var i = 0; i < this.list.length; i++) {
				var tag = this.list[i];
				var re = new RegExp('{' + tag.name + '\\|([^}]+)+}', 'ig');
				var match = null;
				while(match = re.exec(string)) {
					if(match.length == 2) {
						var params = match[1].split('|');
						if(params.length != tag.args) continue;
						switch (tag.name) {
							case 'emoji':
                string = string.replace(match[0], '<svg viewBox="0 0 64 64" width="64" height="64"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#emoji_u1f' + params[0] + '"></use></svg>');
							case 'img':
								string = string.replace(match[0], '<img src="' + params[0] + '">');
								break;
							case 'link':
								string = string.replace(match[0], '<a href="' + params[0] + '" target="_blank">' + params[1] + '</a>');
								break;
							case 'out':
								if(params[2].indexOf('*') === -1) {
									string = string.replace(match[0], '<a class="onicon_chat-ia-link" href="javascript:Onicon.ia.out(' + params[0] + ',' + params[1] + ')">' + params[2] + '</a>');
								} else {
									string = string.replace(match[0], '');
								}
								break;
							case 'end':
								string = string.replace(match[0], '<a class="onicon_chat-ia-link" href="javascript:Onicon.ia.end(' + params[0] + ')">' + params[1] + '</a>');
								break;
                            case 'direct':
                                if (Onicon.core.direct_user) {
                                    var request = Onicon.core.direct_user[params[0]];
                                    if (request) {
                                    	string = string.replace(match[0], request);
                                	}
                                }
                                string = string.replace(match[0], params[1]);
                                break;
						}
					}
				}
			}

			return string;
		},

		hided_formats : [],
		_hideFormat : function(string) {
			var result_string = string;
			var re = /\{(img|link|out|end|emoji)(.+?)\}/gi, m = null, i = 0, hided_formats = [];
			while(m = re.exec(string)) {
				if(m) {
					i++;
					formatter.hided_formats.push({
						id : i,
						value : m[0]
					});

					result_string = result_string.replace(m[0], '%FORMATTER:' + i + '%');
				}
			}

			return result_string;
		},

		_showFormat : function(string) {
			for(var i = 0; i < formatter.hided_formats.length; i++) {
				var format_item = formatter.hided_formats[i];
				string = string.replace('%FORMATTER:' + format_item.id + '%', format_item.value);
			}
			formatter.hided_formats = [];
			return string;
		},

		replaceUrls :  function(string, addParams) {
			string = string.replace(/(?!.*(\"|"|\'|'|\>|>|&gt;|&quot;|&#039;))(?:(?:https|http):\/\/)(?:[^\s]+)/igm, function(s,p,d){
				return '<a href="'+s+'" target="_blank">'+s+'</a>';
			});

			return string;
		},

		addTargetoLink: function (string) {

			return string.replace(/\<\a\ href\=\"(.+?.)\"\>(.+?.)\<\/a\>/gm, function (match, url, name) {
				return '<a href="'+ url +'" target="_blank">'+ name +'</a>';
			});

		},


		replaceEmails :  function(string) {
			return string.replace(/((\s|^)[\w\-\_.]+\w+@(?:[\w-]+\.)+\w+(?::\d+)?)/gi, '<a href="mailto:$1">$1</a>')
		},

		nl2br : function(string) {
			return string.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>');
		},


		replaceVideos: function (string) {

			var $tmpElement = document.createElement('html');
			$tmpElement.innerHTML = string;

			var figure = $($tmpElement).find('figure.media');
			var childFrame = figure.find('iframe');

			if (childFrame.length > 0) {
				figure.replaceWith(function () {
					var src = childFrame[0].src;

					return '<a href="'+src +'" target="_blank">'+ src +'</a>';
				});
			}

			return $tmpElement.innerHTML;
		},

		decodeHtml: function (str) {
			var map =
				{
					'&amp;': '&',
					'&lt;': '<',
					'&gt;': '>',
					'&quot;': '"',
					'&#039;': "'"
				};
			return str.replace(/&amp;|&lt;|&gt;|&quot;|&#039;/g, function(m) {return map[m];});
		},

		encodeHtml: function(str) {
			var map = {
				'&': '&amp;',
				'<': '&lt;',
				'>': '&gt;',
				'"': '&quot;',
				"'": '&#039;'
			};
	
			return str.replace(/[&<>"']/g, function(m) {return map[m];});
		},

		format : function(string, options) {
			if(!string) {
				return string;
			}

			var opts = $.extend({
				addGetParam: {
					// roistat: 'someid'
				}
			}, options);

			string = this.replaceUrls(string);
			string = this.replaceVideos(string);
			string = this.nl2br(string);
			string = this.parse(string);
			string = this.addTargetoLink(string);

			return string;
		}
	};

    var urlParser = {
        parse: function (url) {
            var result = {},
                pos = url.indexOf("?");
            url.substr(pos+1).split("&").forEach(function(part) {
                var item = part.split("=");
                var key = item[0],
                    value = item[1];
                switch (item[0]) {
                    case 'keyword':
                        value = decodeURIComponent(item[1]);
                        break;
                    case '_openstat':
                        // Parse OpenStat
                        var openstat_mark = atob(item[1]).split(';');
                        value = {
                            service: openstat_mark[0],
                            campaign: openstat_mark[1],
                            ad: openstat_mark[2],
                            source: openstat_mark[3]
                        };
                        break;
                }
                result[key] = value;
            });
            return result;
        }
    };

    var colors = {
        getColor: function(color_range, init_range, value, inHex) {
            var mapRange = function(from, to, s) {
                return to[0] + (s - from[0]) * (to[1] - to[0]) / (from[1] - from[0]);
            };
            var vals = function(objects) {
                var vals = [];
                for (var key in objects) {
                    vals.push(objects[key]);
                }
                return vals;
            };
            var rgbToHex = function(color) {
                return "#" + ((1 << 24) + (color.r << 16) + (color.g << 8) + color.b).toString(16).slice(1).toUpperCase();
            };
            var hexToRgb = function(hex) {
                var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
                return result ? {
                    r: parseInt(result[1], 16),
                    g: parseInt(result[2], 16),
                    b: parseInt(result[3], 16)
                } : null;
            };
            var color_one = hexToRgb(color_range[0]),
                color_two = hexToRgb(color_range[1]),
                range = [init_range[0], init_range[1]],
                color_res = {};
            for (var i = 0; i < 3; i++) {
                var c = ['r', 'g', 'b'][i];
                color_res[c] = Math.floor(mapRange(range, [color_one[c], color_two[c]], value));
            }
            if (inHex) {
                return rgbToHex(color_res);
            } else {
                return 'rgb(' + vals(color_res).join(',') + ')';
            }
        },

    darken: function(color, percent, hex) {
        return this.getColor([color,'#000000'],[0,100], percent, hex);
    },

    brighter: function(color, percent, hex) {
        return this.getColor([color,'#FFFFFF'],[0,100], percent, hex);
    }

    };

	var reporting = {
		notify: function(title, message, type, context) {
			new PNotify({
				title: title || 'Onicon Info',
				text: message || 'Пустое тестовое сообщение, системы оповещения пользователя',
				type: type || 'info',
                stack: context || '',
				styling: 'brighttheme'
			});
		},

		confirmDialog: function(container, message, yesCallback, noCallback) {
				var template = Handlebars.compile($('#ConfirmDialogTemplate').html());
				$('#confirm-dialog').remove();
				$(container).append(template({'message': message}));

				var confirm = $('#confirm-dialog');
				confirm.find('.yes').click(function() {
						yesCallback();
						confirm.remove();
				});

				confirm.find('.no').click(function () {
						if(noCallback != undefined) noCallback();
						confirm.remove();
				});
		},

		createLog: function(url, type, message, account_id, site_id, user_id, old_val, new_val) {
			$.ajax({
				url : url, // core.AJAX_URL + "&mode=main&act=log",
				type : "POST",
				dataType : "json",
				data :  {
					params: {
						type: type,
						message: message,
						account_id: account_id,
						site_id: site_id,
						user_id: user_id,
						old_val: old_val,
						new_val: new_val
					}
				},
				success : function(data) {
					console.log('Log was written');
				}
			});
		}
	};

    var validator = {
        validate_fields: function(fields) {
            if(fields.length > 0) {
                for(var i in fields) {
                    var field_value = fields[i].value, check;

                    switch (fields[i].method) {
                        case 'required':
                            check = /^(?=\s*\S).*$/m.test(field_value);
                            break;
                        case 'email':
                            check = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/i.test(dom.trim(field_value));
                            break;
                        case 'phone':
                            check = /^(?=\s*\S).*$/.test(field_value.replace('+', '')) && /^[\+\(\)\-0-9 ]{11,20}$/.test(field_value.replace('+', ''));
                            break;
                        case 'time':
                            check = $.trim(field_value) !== "" && /^(?=\s*\S).*$/.test(field_value) && /^([0-1 ][0-9]|2[0-3]):(0?[0-9]|[1-5][0-9])$/.test(field_value);
                            break;
                        case 'UTC':
                            check = /^(?=\s*\S).*$/.test(field_value) && /^[\+\(\)\-0-9]{1,3}$/.test(field_value);
                            break;
                        case 'max-length':
                            check = (/^[\+\(\)\-0-9]{1,3}$/.test(field_value)) && field_value <= 200 && field_value >= 0;
                            break;
                        default:
                            check = true;
                            break;
                    }

                    if(!check) {
                        this.mark_field(fields[i].input, false);
                        return false;
                    } else {
                        this.mark_field(fields[i].input, true);
                        if(i == fields.length-1) {
                            return true;
                        }
                    }
                }
            } else {
                return true;
            }

        },

        mark_field: function(field, state) {
            if(state) {
                dom.removeClass(field, 'onicon-chat-error');
            } else {
                dom.addClass(field, 'onicon-chat-error');
                // setTimeout(function(){
                //     dom.removeClass(field, 'onicon-chat-error');
                // }, 1000)
            }
        },

        fieldsToObject: function (fields) {
            var result = {};
            for(var i in fields) {
                var input = document.getElementById(fields[i]);

                if (!input) continue;

                //определим что за поле перед нами
                var f_type = input.type, f_value='', f_validate;
                f_validate = input.getAttribute('validate');

                if(f_type == undefined) {
                    var f_class = input.className;
                    if(f_class != undefined) {
                        if(f_class.indexOf('onicon-settings-switcher') != -1) {
                            f_type = 'switcher'
                        } else if(input.nodeName == 'DIV' || input.nodeName == 'SPAN') {
                            f_type = 'text-helper';
                        }
                    }
                }

                switch (f_type) {
                    case 'switcher':
                        f_value = (f_class.indexOf('disabled') != -1) ? 0 : 1;
                        break;
                    case 'text-helper':
                        f_value = (input.textContent != 'Нажмите для редактирования') ? fields[i].textContent : '';
                        break;
                    default:
                        f_value = input.value;
                }

                result[i] = [input, f_value, f_validate];
            }
            return result;
        }

    };



    var button_animation = {
        start: function (animation_id) {

        	var $ = jQuery ? jQuery : Onicon.$;

            var Scene, animation,
                bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

            Scene = (function() {
                function Scene(screen_id) {
                    var fps;
                    this.screen_id = screen_id;
                    this.loop = bind(this.loop, this);
                    fps = 25;
                    this.screen = $(this.screen_id);
                    this.then = Date.now();
                    this.interval = 1000 / fps;
                    if (this.screen.length) {
                        this.loop();
                    }
                }

                Scene.prototype.loop = function() {
                    var delta, now;
                    requestAnimationFrame(this.loop);
                    now = Date.now();
                    delta = now - this.then;
                    if (delta > this.interval) {
                        this.then = now - (delta % this.interval);
                        return this.draw();
                    }
                };

                Scene.prototype.draw = function() {
                    var bpx;
                    bpx = this.screen.css('background-position').split(' ');
                    return this.screen.css('background-position', (parseInt(bpx) - 50) + 'px 0');
                };

                return Scene;

            })();
            animation = new Scene(animation_id);
        }
    };

	Onicon
		.lib('dom', dom, true)
		.lib('reporting', reporting, true)
		.lib('formatter', formatter, true)
		.lib('trigger', trigger, true)
		.lib('datesync', datesync, true, true)
		.lib('storage', mStorage)
		.lib('session_storage', session_storage, true)
		.lib('local_storage', local_storage, true)
		.lib('url_parser', urlParser, true)
		.lib('colors', colors, true)
        .lib('validator', validator, true)
        .lib('buttonAnimation', button_animation, true);

})();
